import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCheckCircle, faCopy, faFileInvoice, faPlus,
} from '@fortawesome/pro-light-svg-icons'

import { digObject } from '@domain-group/javascript-utils'
import { Button, Tools } from '@domain-group/suit-theme'

import useCurrentUser from '@hooks/useCurrentUser'

import handleCallbackAction from '@functions/handleCallbackAction'
import { getCampaignPermissions, getCampaignType } from '@functions/campaign'
import useCampaignSelector from '@hooks/useCampaignSelector'
import useAgencySelector from '@hooks/useAgencySelector'
import useBrand from '@hooks/useBrand'

interface ToolsProps {
  callbacks: {
    addCustomItem: VoidFunction,
    createInvoiceFromItems: VoidFunction,
    showGenerateCampaignScheduleModal: VoidFunction,
    toggleAllItems: VoidFunction,
  },
  canGenerateSchedule? : boolean,
  hasSelectedItems: boolean,
}

const ApprovedOrderTools = (props: ToolsProps) => {
  const {
    callbacks: {
      addCustomItem,
      createInvoiceFromItems: createInvoiceFn,
      showGenerateCampaignScheduleModal,
      toggleAllItems,
    },
    canGenerateSchedule = false,
    hasSelectedItems,
  } = props

  const { campaign } = useCampaignSelector()
  const { currentUser } = useCurrentUser()
  const campaignPermissions = getCampaignPermissions({
    user: currentUser,
    campaignType: getCampaignType(campaign),
  })
  const { brand } = useAgencySelector()
  const { compliantWithAML} = useBrand({id: brand.id})
  const requiresQuote = campaignPermissions?.orders?.require_quote || false

  return (
    <Tools>
      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faCheckCircle} />}
        onClick={toggleAllItems}
        size="medium"
      >
        Toggle All
      </Button>

      {!requiresQuote && (
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={addCustomItem}
          //@ts-expect-error
          marginTop="medium"
          size="medium"
          disabled={compliantWithAML && !campaign.vendor_aml_complete}
        >
          Add Custom Item
        </Button>
      )}

      {canGenerateSchedule && (
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faCopy} />}
          onClick={showGenerateCampaignScheduleModal}
          size="medium"
          //@ts-expect-error
          marginTop="medium"
        >
          Generate Schedule
        </Button>
      )}

      {hasSelectedItems && (
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faFileInvoice} />}
          onClick={() => handleCallbackAction({
            callbacks: {
              // @ts-expect-error TS2322
              action: createInvoiceFn,
            },
            shouldRedirect: true,
            toastText: 'Invoice Created',
          })}
          //@ts-expect-error
          marginTop="medium"
          size="medium"
        >
          Create Invoice
        </Button>
      )}
    </Tools>
  )
}

export default ApprovedOrderTools
